<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Reduction Of Manpower
    </div>
    <div class="card-body">
        <form (ngSubmit)="Validate(FilterForm)" #FilterForm="ngForm" name="FilterForm" novalidate>
            <div class="row py-1">
                <div class="col-md-3">
                    <label class="Label">Work Order Date<span class="text-danger"
                            *ngIf="(Filter.WorkOrderNumber != null && Filter.WorkOrderNumber != '')">*</span></label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="WorkOrderDate"
                            [(ngModel)]="Filter.WorkOrderDate" ngbDatepicker #WorkOrderDate="ngbDatepicker" readonly
                            [required]="(Filter.WorkOrderNumber != null && Filter.WorkOrderNumber != '')"
                            [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="WorkOrderDate.toggle()"
                            type="button"></button>
                        <div class="invalid-feedback">
                            Please enter work order date.
                        </div>
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="Label">Work Order No.</label>
                    <input name="workorderno" [(ngModel)]="Filter.WorkOrderNumber" type="text" class="form-control"
                        [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction" />
                </div>
                <div class="col-md-2" *ngIf="this.Filter.ESS_ShiftWiseManpowerMasterId > 0">
                    <label class="Label">Entry No.</label>
                    <input name="entryNo" type="text" [(ngModel)]="Filter.EntryNo" class="form-control" disabled />
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-5">
                    <label class="Label">Branch<span class="text-danger">*</span></label>
                    <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="Select Branch" [(ngModel)]="Filter.BranchID" name="Branch"
                        (change)="ComboLoad('Client')" required [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch.
                    </div>
                </div>
                <div class="col-md-5">
                    <label class="Label">Client<span class="text-danger">*</span></label>
                    <ng-select [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                        placeholder="Select Client" [(ngModel)]="Filter.ClientID" name="Client"
                        (change)="ComboLoad('Site')" required [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select client.
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-10">
                    <label class="Label">Site<span class="text-danger">*</span></label>
                    <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID" placeholder="Select Site"
                        [(ngModel)]="Filter.SiteID" name="Site" required
                        [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select site.
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-4">
                    <label class="Label">Attachment</label>
                    <div class="file-input-container">
                        <input *ngIf="this.Filter.Filename == null" class="form-control form-control-sm" id="formFileSm"
                            type="file" accept=".pdf" (change)="onFileSelected($event)"
                            [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction" />
                        <span *ngIf="this.Filter.Filename != null" class="file-name">{{ SplitName() }}</span>
                        <span *ngIf="this.Filter.Filename != null"> <button type="button" class="btn btn-sm" name="view"
                                style="color: blue;" (click)="viewFile()"><i class="bi bi-eye"></i></button></span>
                        <button type="button" class="btn btn-sm" *ngIf="this.Filter.Filename != null"
                            (click)="removeFile()"
                            [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label class="Label">Allocation Type</label>
                    <input name="addition" [(ngModel)]="Filter.AllocationTypes" type="text" class="form-control"
                        disabled />
                </div>
                <div class="col-md-auto"><br>
                    <button class="btn btn btn-primary" name="selectworkorder"
                        *ngIf="(this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit)"
                        [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction"><i
                            class="bi bi-funnel-fill"></i>Select
                        Workorder</button>
                </div>
                <div class="col"></div>
                <div class="col-md-auto"><br>
                    <span class="badge view" style="font-size: small;height: auto;">Reduction: {{this.Card.Reduction}}</span>
                </div>
            </div>
        </form>

        <div class="card border-radius-0 mt-1 p-0">
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Entry No</th>
                            <th scope="col">WO No.</th>
                            <th scope="col">WO Dt. </th>
                            <th scope="col">Designation Name</th>
                            <th scope="col">Duty Name</th>
                            <th scope="col">Shift Name</th>
                            <th scope="col">Balance</th>
                            <th scope="col">Reduction Count</th>
                            <th scope="col">Reduction Date</th>
                            <th scope="col">Remarks</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of RedManpowers; let i = index">
                            <th scope="row" [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{i + 1 }}</th>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">
                                {{element.RefAdditionEntryNo}}
                            </td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{ element.WONo }}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{ element.WODate }}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{ element.DesignationName }}
                            </td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{ element.DutyName }}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{ element.ShiftTitle }}</td>
                            <td class="text-end" [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">
                                <span class="no-of-person">{{element.Balance}}</span>
                            </td>
                            <td class="text-end" [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">
                                <span class="no-of-person">{{element.NoOfPerson}}
                                </span>
                            </td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.FromDate}}</td>
                            <td [ngClass]="{'highlight-row': element.IsMonthLocked == 1}">{{element.Remarks}}</td>
                            <td
                                [ngClass]="{'highlight-row colHide': element.IsMonthLocked == 1 || Filter.IsAutoReduction}">
                                <button class="btn btn-sm" name="delete" style="color: red;" (click)="deleteRow(i)"><i
                                        class="bi bi-trash-fill"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn btn-primary mx-1" name="save" (click)="save()"
                    *ngIf="(this.Filter.ESS_ShiftWiseManpowerMasterId == 0 && this.common.PageRight.IsAdd) || (this.Filter.ESS_ShiftWiseManpowerMasterId > 0 && this.common.PageRight.IsEdit)"
                    [disabled]="Filter.ESS_ShiftWiseManpowerMasterId > 0 && Filter.IsAutoReduction">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
                <button type="button" class="btn btn-primary mx-1" name="refresh" (click)="Back()">
                    <i class="bi bi-arrow-left" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Back':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>